import React, { useState } from "react";
import VisibilitySensor from "react-visibility-sensor";
import "./WhyChoose.css";

const strengths = [
  {
    id: 1,
    title: "YOUNG ENTREPRENEURS",
    description: "Driving innovation with energy, creativity, and forward-thinking solutions.",
    iconNormal: "/assets/img/YoungEnterpreneurs-new.png",
    iconHover: "/assets/img/YoungEnterpreneurs_white.png",
  },
  {
    id: 2,
    title: "EXPERIENCED OPERATIONS",
    description: "Leveraging 5–15 years of practical experience to ensure smooth execution.",
    iconNormal: "/assets/img/ExperiencedOperations-new.png",
    iconHover: "/assets/img/ExperiencedOperations_white.png",
  },
  {
    id: 3,
    title: "EXPERT ADVISORS",
    description: "Providing strategic guidance through industry and technical expertise.",
    iconNormal: "/assets/img/ExpertAdvisor-new.png",
    iconHover: "/assets/img/ExpertAdvisor_white.png",
  },
];

function WhyChoose() {
  const [hoveredCards, setHoveredCards] = useState({});
  const [isVisible, setIsVisible] = useState(false);

  const handleMouseEnter = (cardId) => {
    setHoveredCards((prevHoveredCards) => ({
      ...prevHoveredCards,
      [cardId]: true,
    }));
  };

  const handleMouseLeave = (cardId) => {
    setHoveredCards((prevHoveredCards) => ({
      ...prevHoveredCards,
      [cardId]: false,
    }));
  };

  const handleVisibilityChange = (visible) => {
    if (visible && !isVisible) {
      setIsVisible(true);
    }
  };

  return (
    <div>
      <section className="promo-section ptb-100 section-below-banner three-strengths-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-12 col-lg-9">
              <div className="section-heading text-center">
                <h2 className="web">Crafted Around Three Strengths</h2>
              </div>
            </div>
          </div>
          
          <VisibilitySensor onChange={handleVisibilityChange} partialVisibility>
            <div className="strengths-content">
              <div className="layout-pill">
                {strengths.map((strength, index) => (
                  <div 
                    key={strength.id} 
                    className={`pill-item ${isVisible ? 'visible' : ''}`}
                    onMouseEnter={() => handleMouseEnter(strength.id)}
                    onMouseLeave={() => handleMouseLeave(strength.id)}
                    style={{ animationDelay: `${index * 0.15}s` }}
                  >
                    <div className="pill-icon">
                      <img
                        src={hoveredCards[strength.id] ? strength.iconHover : strength.iconNormal}
                        alt={strength.title}
                      />
                    </div>
                    <div className="pill-content">
                      <h5>{strength.title}</h5>
                      <p>{strength.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </VisibilitySensor>
        </div>
      </section>
    </div>
  );
}

export default WhyChoose;
